import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
/**
 * PC:求人詳細タブ下部 写真コンテンツのvisible計測.
 */
export const measureVisiblePublicationPhotoArea = () => {
  // カスタムリンク
  tl('Tgenkou_photo_jobdescription_visible', {});
};
/**
 * PC:求人詳細タブ下部 「写真をもっと見る」visible計測.
 */
export const measureVisiblePublicationPhotoLink = () => {
  // カスタムリンク
  tl('Tgenkou_photo_jobdescription_morepic_visible', {});
};
